import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Section, Container, Eyebrow, DisplayH1 } from "@/components/Layout";
import ProgramCard from "@/components/ProgramCard";
import { api } from "@/lib/api";

export default function Programs() {
  const [programs, setPrograms] = useState([]);
  useEffect(() => { api.get("/programs").then((r) => setPrograms(r.data.programs || [])); }, []);

  return (
    <>
      <Section testid="programs-header" className="pt-40 pb-16">
        <Container>
          <Eyebrow>The Academies · 2026 Season</Eyebrow>
          <DisplayH1 className="mt-6 max-w-4xl">Nine programs. <span className="text-[color:var(--wk-bone-dim)]">One institution.</span></DisplayH1>
          <p className="mt-8 max-w-2xl text-lg text-[color:var(--wk-bone-dim)] leading-relaxed">
            Every academy is led by a faculty specialist, taught with peer-reviewed methodology,
            and delivered inside our residence programs, mobile field labs, or online university.
          </p>
        </Container>
      </Section>
      <Section testid="programs-grid" className="pb-28">
        <Container>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {programs.map((p, i) => <ProgramCard key={p.slug} program={p} index={i} />)}
          </div>
          <div className="mt-16 text-center">
            <Link to="/apply" className="btn-gold" data-testid="programs-apply">Apply to any program</Link>
          </div>
        </Container>
      </Section>
    </>
  );
}
